export type AssignmentMemberSearchRecord = {
  id: string;
  fullName: string;
  email: string;
  tenant?: string;
};

/** Matches a concierge assignment member by name, email, or customer id. */
export function filterAssignmentMemberSearch<T extends AssignmentMemberSearchRecord>(
  members: Array<T>,
  query: string,
): Array<T> {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return [];
  }

  return members.filter((member) =>
    [member.fullName, member.email, member.id].join('\n').toLowerCase().includes(normalized),
  );
}
